import { BasicEnumerable } from "../BasicEnumerable.js";
export const groupJoin = (outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) => {
    const generator = comparer ?
        groupJoinWithComparer(outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) :
        groupJoinSimple(outer, inner, outerKeySelector, innerKeySelector, resultSelector);
    return new BasicEnumerable(generator);
};
const groupJoinWithComparer = (outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) => {
    return function* () {
        const innerKeyMap = [];
        for (const innerValue of inner) {
            const key = innerKeySelector(innerValue);
            const record = innerKeyMap.find(x => comparer(x.key, key));
            if (record) {
                record.values.push(innerValue);
            }
            else {
                innerKeyMap.push({ key, values: [innerValue] });
            }
        }
        for (const outerValue of outer) {
            const key = outerKeySelector(outerValue);
            const innerRecord = innerKeyMap.find(x => comparer(x.key, key)) ?? { key, values: [] };
            yield resultSelector(outerValue, innerRecord.values);
        }
    };
};
const groupJoinSimple = (outer, inner, outerKeySelector, innerKeySelector, resultSelector) => {
    return function* () {
        const innerKeyMap = new Map();
        for (const innerValue of inner) {
            const key = innerKeySelector(innerValue);
            const values = innerKeyMap.get(key);
            if (values) {
                values.push(innerValue);
            }
            else {
                innerKeyMap.set(key, [innerValue]);
            }
        }
        for (const outerValue of outer) {
            const key = outerKeySelector(outerValue);
            const values = innerKeyMap.get(key) ?? [];
            yield resultSelector(outerValue, values);
        }
    };
};
